export default{
    changePhone:{
        titleState:{
            title1:'Identity Verification',
            title2:'Change Mobile Number',
            title3:'Change Completed',
            title4:'Current Mobile:',
            title5:'If this number is no longer accessible, please contact customer service',
        },
        showList:{
            show1:'Verification Code:',
            show2:'Enter SMS verification code',
            show3:'Next',
            show4:'New Mobile Number:',
            show5:'Enter new mobile number',
            show6:'Mobile number changed successfully',
            show7:'You can now log in with your new number',
            show8:'Back',
            show9:'Get Verification Code',
            show10:'Enter verification code',
            show11:'Verification code sent to',
            show15:', please check your messages',
            show12:'Resend in',
            show13:'Enter mobile number',
            show14:'Enter valid mobile number',
        },
    }
}